import axios, { AxiosResponse } from "axios";
import { CategoryDto } from "../../dto/category.dto";

export function fetchCategories(
  clientCode: string
): Promise<AxiosResponse<CategoryDto[]>> {
  return axios.post("categories", {
    code: clientCode,
  });
}
